import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import shadow from '../../assets/images/my_business/item_page_shadow.png';

const StyledContainer = styled.div``;

const StyledHeadContainer = styled.div`
	position: relative;
	padding: 20px;
	border-bottom: 1px solid rgba(217, 217, 217, 0.1);

	& > ${Text} {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		font-weight: 700;
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledItemContainer = styled.div`
	display: grid;
	grid-template-columns: 268px 1px 1fr;
	gap: 30px;
	padding: 30px;
	background: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 10px;
	margin: 20px;
`;

const StyledItemLeftContainer = styled.div`
	position: relative;
	width: 268px;
	height: 268px;
	img {
		position: relative;
		z-index: 2;
	}
`;

const StyledShadow = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 420px;
	height: 420px;
	background-image: url(${shadow});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

const StyledItemRightContainer = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	margin-top: -3px;
`;

const StyledPriceContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const StyledPrice = styled.div`
	display: flex;
	gap: 6px;
	align-items: center;
`;

const StyledButtonsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 10px;
`;

const StyledInfoGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-template-rows: 160px 160px;
	gap: 10px;
	margin: 20px;
`;

export {
	StyledButtonsContainer,
	StyledContainer,
	StyledHeadContainer,
	StyledInfoGrid,
	StyledItemContainer,
	StyledItemLeftContainer,
	StyledItemRightContainer,
	StyledPrice,
	StyledPriceContainer,
	StyledShadow,
};
